import { render, staticRenderFns } from "./FragmentGallery.vue?vue&type=template&id=8b7b9ae8&"
import script from "./FragmentGallery.vue?vue&type=script&lang=ts&"
export * from "./FragmentGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports